export const mainFont = '"Open Sans", sans-serif';
export const iconsFont = 'glyphicons-theme';

export default {
    mainFont,
    iconsFont,
};
